import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";

export default function AboutPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-10">
      <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Par mums</h1>
      <div className="mt-6 space-y-5 text-base leading-relaxed text-slate-700">
        <p>DANS G ir uzticams partneris tehniskiem risinājumiem — mēs pārstāvam vairāk nekā 20 ārvalstu rūpnīcas Latvijā. Piedāvājam motoreļļas, auto spuldzes, smērvielas, krāsas un auto ķīmiju gan privātpersonām, gan uzņēmumiem.</p>
        <p>Mūsu specializācija ir apjoma piegādes B2B klientiem: lauksaimniekiem, auto servisiem, autoparkiem un ražotnēm. Eļļas piegādājam fasējumos no 1L pudeles līdz 205L mucām un 1000L IBC konteineriem.</p>
        <p>Tādi profesionāli atslēgas vārdi kā pārdošana, mārketings, veicināšana, izplatīšana un augsts klientu apkalpošanas serviss ir mūsu ceļš uz panākumiem!</p>
      </div>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        {[["20+", "pārstāvētie zīmoli"], ["2500+", "preces katalogā"], ["1–2", "dienas piegāde Latvijā"], ["200+", "pastāvīgie B2B klienti"]].map(([n, t]) => (
          <div key={t} className="rounded-2xl border border-border bg-white p-5 text-center">
            <p className="font-heading text-2xl font-bold text-[#2E86D1]">{n}</p>
            <p className="mt-1 text-xs text-slate-500">{t}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/b2b" data-testid="about-b2b-link" className="btn-industrial bg-[#2E86D1] px-6 py-3 text-sm font-semibold text-white hover:bg-[#1F6DB2]">B2B sadarbība</Link>
        <Link to="/kontakti" className="btn-industrial border border-slate-300 px-6 py-3 text-sm font-semibold hover:bg-[#2E86D1] hover:text-white hover:border-[#2E86D1]">Kontakti</Link>
      </div>
    </div>
  );
}

export function ContactsPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-10">
      <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Kontakti</h1>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
        {[
          { icon: Phone, t: "Tālrunis", d: "+371 67 000 000", sub: "Darba dienās 8:00–18:00" },
          { icon: EnvelopeSimple, t: "E-pasts", d: "info@e-dansg.lv", sub: "Atbildam 1 darba dienas laikā" },
          { icon: MapPin, t: "Noliktava un birojs", d: "Rīga, Latvija", sub: "Preču saņemšana uz vietas" },
          { icon: Clock, t: "Darba laiks", d: "P.–Pk. 8:00–18:00", sub: "Se., Sv. — slēgts" },
        ].map((c) => (
          <div key={c.t} className="rounded-2xl border border-border bg-white p-6 flex items-start gap-4">
            <c.icon size={26} className="shrink-0 text-[#2E86D1]" />
            <div>
              <p className="text-xs font-semibold tracking-[0.15em] uppercase text-slate-500">{c.t}</p>
              <p className="mt-1 font-heading text-lg font-semibold">{c.d}</p>
              <p className="text-xs text-slate-500">{c.sub}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 rounded-2xl bg-[#2E86D1] p-8 text-white flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-heading text-xl font-semibold">Nepieciešams piedāvājums lielam apjomam?</p>
          <p className="mt-1 text-sm text-blue-100">Aizpildiet pieprasījumu — B2B menedžeris sazināsies 1 darba dienas laikā.</p>
        </div>
        <Link to="/piedavajums" data-testid="contacts-quote-link" className="btn-industrial bg-white px-6 py-3 text-sm font-semibold text-[#2E86D1] hover:bg-blue-50">Pieprasīt piedāvājumu</Link>
      </div>
    </div>
  );
}
